class CompleteTheFit {
  constructor(section) {
    this.section = section;

    this.productId = section.dataset.productId;

    this.limit = section.dataset.limit || 3;

    this.productsContainer = section.querySelector(
      "[data-complete-the-fit-products]",
    );

    this.init();
  }

  async init() {
    if (!this.productId || !this.productsContainer) {
      return;
    }

    try {
      const url =
        `${window.Shopify.routes.root}` +
        `recommendations/products` +
        `?section_id=complete-the-fit-recommendations` +
        `&product_id=${this.productId}` +
        `&limit=${this.limit}` +
        `&intent=complementary`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Unable to load recommendations");
      }

      const html = await response.text();

      const wrapper = document.createElement("div");

      wrapper.innerHTML = html;

      const recommendations = wrapper.querySelector(
        ".complete-the-fit-recommendations",
      );

      if (!recommendations) {
        this.productsContainer.innerHTML = "";

        return;
      }

      this.productsContainer.innerHTML = recommendations.outerHTML;

      this.bindEvents();
    } catch (error) {
      console.error("Complete The Fit:", error);

      this.productsContainer.innerHTML = "";
    }
  }

  bindEvents() {

    /* =========================================
   SIZE DROPDOWN OPEN / CLOSE
========================================= */

this.productsContainer
  .querySelectorAll("[data-size-dropdown]")
  .forEach((dropdown) => {
    const button = dropdown.querySelector(
      "[data-size-dropdown-button]"
    );

    const menu = dropdown.querySelector(
      "[data-size-dropdown-menu]"
    );

    if (!button || !menu) return;

    button.addEventListener("click", (event) => {
      event.stopPropagation();

      const isOpen =
        button.getAttribute("aria-expanded") === "true";

      this.closeAllColorDropdowns();

      button.setAttribute("aria-expanded", String(!isOpen));
      menu.hidden = isOpen;
    });
  });

/* =========================================
   SIZE OPTION CLICK
========================================= */

this.productsContainer
  .querySelectorAll("[data-size-option]")
  .forEach((option) => {
    option.addEventListener("click", () => {
      const card = option.closest(".complete-fit-product");

      if (!card) return;

      const variantId = option.dataset.variantId;

      if (!variantId) return;

      // Update selected size label
      const selectedLabel = card.querySelector(
        "[data-size-selected-label]"
      );

      if (selectedLabel) {
        selectedLabel.textContent = option.textContent.trim();
      }

      // Update selected option styling
      card.querySelectorAll("[data-size-option]").forEach((item) => {
        const selected =
          item.dataset.variantId === variantId;

        item.classList.toggle("is-selected", selected);

        item.setAttribute(
          "aria-selected",
          String(selected)
        );
      });

      // Update the selected variant and add-on checkbox
      this.updateSelectedVariant(card, variantId);

      // Close size dropdown
      const dropdown = option.closest("[data-size-dropdown]");

      if (dropdown) {
        const button = dropdown.querySelector(
          "[data-size-dropdown-button]"
        );

        const menu = dropdown.querySelector(
          "[data-size-dropdown-menu]"
        );

        if (button) {
          button.setAttribute("aria-expanded", "false");
        }

        if (menu) {
          menu.hidden = true;
        }
      }
    });
  });


    /* =========================================
       SIZE
    ========================================= */

    this.productsContainer
      .querySelectorAll("[data-size-select]")
      .forEach((select) => {
        select.addEventListener("change", () => {
          const card = select.closest(".complete-fit-product");

          if (!card) return;

          this.updateSelectedVariant(card, select.value);
        });
      });

    /* =========================================
       COLOR DROPDOWN OPEN/CLOSE
    ========================================= */

    this.productsContainer
      .querySelectorAll("[data-color-dropdown]")
      .forEach((dropdown) => {
        const button = dropdown.querySelector("[data-color-dropdown-button]");

        const menu = dropdown.querySelector("[data-color-dropdown-menu]");

        if (!button || !menu) {
          return;
        }

        button.addEventListener("click", (event) => {
          event.stopPropagation();

          const isOpen = button.getAttribute("aria-expanded") === "true";

          /*
           * Close every other
           * color dropdown.
           */

          this.closeAllColorDropdowns(dropdown);

          button.setAttribute("aria-expanded", String(!isOpen));

          menu.hidden = isOpen;
        });
      });

    /* =========================================
       COLOR OPTIONS
    ========================================= */

    this.productsContainer
      .querySelectorAll("[data-color-option]")
      .forEach((option) => {
        option.addEventListener("click", async () => {
          const card = option.closest(".complete-fit-product");

          if (!card) return;

          /*
           * Update product FIRST.
           */

          await this.changeColor(card, option);

          /*
           * Then close dropdown.
           */

          const dropdown = option.closest("[data-color-dropdown]");

          if (dropdown) {
            const button = dropdown.querySelector(
              "[data-color-dropdown-button]",
            );

            const menu = dropdown.querySelector("[data-color-dropdown-menu]");

            if (button) {
              button.setAttribute("aria-expanded", "false");
            }

            if (menu) {
              menu.hidden = true;
            }
          }
        });
      });

    /* =========================================
       COLOR SWATCHES
    ========================================= */

    this.productsContainer
      .querySelectorAll("[data-color-swatch]")
      .forEach((swatch) => {
        swatch.addEventListener("click", async () => {
          const card = swatch.closest(".complete-fit-product");

          if (!card) return;

          const option = card.querySelector(
            `[data-color-option][data-product-id="${swatch.dataset.productId}"]`,
          );

          if (!option) return;

          /*
           * Same exact color-change
           * logic as dropdown.
           */

          await this.changeColor(card, option);
        });
      });

    /* =========================================
       CHECKBOX
    ========================================= */

    this.productsContainer
      .querySelectorAll("[data-addon-checkbox]")
      .forEach((checkbox) => {
        checkbox.addEventListener("change", () => {
          const card = checkbox.closest(".complete-fit-product");

          if (!card) return;

          this.updateSelectedVariant(card, checkbox.dataset.variantId);
        });
      });
  }

  /* =========================================
     CHANGE COLOR
  ========================================= */

  async changeColor(card, colorOption) {
    if (!card || !colorOption) {
      return;
    }

    const productId = colorOption.dataset.productId;

    const handle = colorOption.dataset.productHandle;

    const variantId = colorOption.dataset.variantId;


    card.dataset.productId = productId;
    card.dataset.productHandle = handle;
    card.dataset.variantId = variantId;

    /* =========================================
       IMAGE
    ========================================= */

    const image = card.querySelector("[data-product-image]");
    if (image && colorOption.dataset.productImage) {
      image.src = colorOption.dataset.productImage;

      image.alt = colorOption.dataset.productImageAlt || "";
    }

    /* =========================================
       TITLE
    ========================================= */

    const title = card.querySelector("[data-product-title]");
    if (title) {
      title.textContent = colorOption.dataset.productTitle || "";
    }

    /* =========================================
       PRICE
    ========================================= */

    const price = card.querySelector("[data-product-price]");
    if (price) {
      price.textContent = colorOption.dataset.productPrice || "";
    }

    /* =========================================
       COLOR SELECT DISPLAY
    ========================================= */

    this.updateColorButton(card, colorOption);

    /* =========================================
       COLOR DROPDOWN SELECTED OPTION
    ========================================= */

    card.querySelectorAll("[data-color-option]").forEach((option) => {
      const selected = option.dataset.productId === productId;

      option.classList.toggle("is-selected", selected);
    });

    /* =========================================
       COLOR SWATCHES
    ========================================= */

    card.querySelectorAll("[data-color-swatch]").forEach((swatch) => {
      const selected = swatch.dataset.productId === productId;

      swatch.classList.toggle("is-selected", selected);

      if (selected) {
        swatch.setAttribute("aria-current", "true");
      } else {
        swatch.removeAttribute("aria-current");
      }
    });

    /* =========================================
       CHECKBOX
    ========================================= */

    const checkbox = card.querySelector("[data-addon-checkbox]");
    if (checkbox) {
      checkbox.dataset.productId = productId;
      checkbox.dataset.variantId = variantId;
      checkbox.value = variantId;
    }

    /* =========================================
       LOAD SELECTED PRODUCT
    ========================================= */

    if (!handle) {
      return;
    }

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}products/${handle}.js`,
      );

      if (!response.ok) {
        throw new Error("Unable to fetch product");
      }

      const product = await response.json();

      this.renderSizes(card, product, variantId);
    } catch (error) {
      console.error("Complete The Fit:", error);
    }
  }

  async changeColor(card, colorOption) {
    if (!card || !colorOption) return;

    // console.log("Selected color:", colorOption.dataset.colorValue);
    // console.log("Selected color:", colorOption.dataset.colorValue);

    const productId = colorOption.dataset.productId;
    const handle = colorOption.dataset.productHandle;
    const variantId = colorOption.dataset.variantId;

    /*
     * DO NOT MODIFY colorOption.innerHTML
     * DO NOT MODIFY any [data-color-option] innerHTML
     */

    // Product image
    const image = card.querySelector("[data-product-image]");
    if (image && colorOption.dataset.productImage) {
      image.src = colorOption.dataset.productImage;
      image.alt = colorOption.dataset.productImageAlt || "";
    }

    // Product title
    const title = card.querySelector("[data-product-title]");
    if (title) {
      title.textContent = colorOption.dataset.productTitle || "";
    }

    // Product price
    const price = card.querySelector("[data-recommended-price]");
    if (price) {
      price.textContent = colorOption.dataset.productPrice || "";
    }

    /*
     * Update ONLY the color selector at the top.
     */
    const selectedLabel = card.querySelector("[data-color-selected-label]");

    if (selectedLabel) {
      selectedLabel.textContent = colorOption.dataset.colorValue || "Color";
    }

    const selectedSwatch = card.querySelector("[data-color-selected-swatch]");
    if (selectedSwatch) {
      selectedSwatch.style = colorOption.dataset.swatchStyle || "";
      selectedSwatch.hidden = false;
    }

    /*
     * Update selected swatch underneath.
     *
     * We only toggle classes.
     * We DON'T change their HTML.
     */

    card.querySelectorAll("[data-color-swatch]").forEach((swatch) => {
      const selected = swatch.dataset.productId === productId;

      swatch.classList.toggle("is-selected", selected);
    });

    /*
     * Update checkbox.
     */

    const checkbox = card.querySelector("[data-addon-checkbox]");

    if (checkbox) {
      checkbox.dataset.productId = productId;
      checkbox.dataset.variantId = variantId;
      checkbox.value = variantId;
    }

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}products/${handle}.js`,
      );

      if (!response.ok) {
        throw new Error("Unable to fetch product");
      }

      const product = await response.json();

    //   console.log("Selected product:", product);

      this.renderSizes(card, product, variantId);
    } catch (error) {
      console.error("Complete The Fit:", error);
    }
  }


  // renderSizes(card, product, currentVariantId) {
  //   const sizeSelect = card.querySelector("[data-size-select]");

  //   if (!sizeSelect || !product) {
  //     return;
  //   }

  //   sizeSelect.innerHTML = "";

  //   let selectedVariant = product.variants.find(
  //     (variant) => String(variant.id) === String(currentVariantId),
  //   );

  //   if (!selectedVariant || !selectedVariant.available) {
  //     selectedVariant = product.variants.find((variant) => variant.available);
  //   }

  //   /*
  //    * Add available variants.
  //    */

  //   product.variants
  //     .filter((variant) => variant.available)
  //     .forEach((variant) => {
  //       const option = document.createElement("option");
  //       option.value = variant.id;
  //       option.dataset.variantId = variant.id;
  //       option.textContent = variant.title;
  //       if (
  //         selectedVariant &&
  //         String(variant.id) === String(selectedVariant.id)
  //       ) {
  //         option.selected = true;
  //       }

  //       sizeSelect.appendChild(option);
  //     });

  //   if (selectedVariant) {
  //     this.updateSelectedVariant(card, selectedVariant.id);
  //   }
  // }

  renderSizes(card, product, currentVariantId) {
  const sizeMenu = card.querySelector(
    "[data-size-dropdown-menu]"
  );

  const sizeLabel = card.querySelector(
    "[data-size-selected-label]"
  );

  const sizeButton = card.querySelector(
    "[data-size-dropdown-button]"
  );

  const checkbox = card.querySelector(
    "[data-addon-checkbox]"
  );

  if (!sizeMenu || !product) return;

  // Get available variants for the selected color
  const availableVariants = product.variants.filter(
    (variant) => variant.available
  );

  // Prefer the current variant if available
  let selectedVariant = availableVariants.find(
    (variant) =>
      String(variant.id) === String(currentVariantId)
  );

  // Otherwise select the first available variant
  if (!selectedVariant) {
    selectedVariant = availableVariants[0];
  }

  // Rebuild size options
  sizeMenu.innerHTML = "";

  availableVariants.forEach((variant) => {
    const option = document.createElement("button");

    option.type = "button";
    option.className = "complete-fit-color-option";
    option.dataset.sizeOption = "";
    option.dataset.variantId = String(variant.id);
    option.setAttribute("role", "option");

    const selected =
      selectedVariant &&
      String(variant.id) === String(selectedVariant.id);

    option.classList.toggle("is-selected", Boolean(selected));

    option.setAttribute(
      "aria-selected",
      String(Boolean(selected))
    );

    const name = document.createElement("span");

    name.className = "complete-fit-color-option__name";
    name.textContent = variant.title;

    option.appendChild(name);

    option.addEventListener("click", () => {
      if (sizeLabel) {
        sizeLabel.textContent = variant.title;
      }

      sizeMenu.querySelectorAll("[data-size-option]").forEach(
        (item) => {
          const isSelected =
            item.dataset.variantId === String(variant.id);

          item.classList.toggle("is-selected", isSelected);

          item.setAttribute(
            "aria-selected",
            String(isSelected)
          );
        }
      );

      this.updateSelectedVariant(card, variant.id);

      const dropdown = card.querySelector(
        "[data-size-dropdown]"
      );

      if (dropdown) {
        const button = dropdown.querySelector(
          "[data-size-dropdown-button]"
        );

        if (button) {
          button.setAttribute("aria-expanded", "false");
        }

        sizeMenu.hidden = true;
      }
    });

    sizeMenu.appendChild(option);
  });

  // =========================================
  // UNAVAILABLE STATE
  // =========================================

  if (!selectedVariant) {
    if (sizeLabel) {
      sizeLabel.textContent = "Sold Out";
    }

    // Add class to the current card's size button
    if (sizeButton) {
      sizeButton.classList.add("unavailable");
      sizeButton.setAttribute("aria-disabled", "true");
    }

    // Close the size dropdown
    const dropdown = card.querySelector(
      "[data-size-dropdown]"
    );

    if (dropdown) {
      if (sizeButton) {
        sizeButton.setAttribute("aria-expanded", "false");
      }

      sizeMenu.hidden = true;
    }

    // Disable and uncheck the add-on checkbox
    if (checkbox) {
      checkbox.checked = false;
      checkbox.disabled = true;

      // Clear the unavailable variant ID
      checkbox.dataset.variantId = "";
      checkbox.value = "";

      // Update the selected products array
      checkbox.dispatchEvent(
        new Event("change", { bubbles: true })
      );
    }

    // Clear the selected variant IDs on this card
    card.dataset.variantId = "";
    card.dataset.selectedVariantId = "";

    return;
  }

  // =========================================
  // AVAILABLE STATE
  // =========================================

  if (sizeLabel) {
      sizeLabel.textContent = selectedVariant.title;
    }

    // Remove unavailable styling
    if (sizeButton) {
      sizeButton.classList.remove("unavailable");
      sizeButton.removeAttribute("aria-disabled");
    }

    // Re-enable the add-on checkbox
    if (checkbox) {
      checkbox.disabled = false;
    }

    // Sync the selected variant ID
    this.updateSelectedVariant(card, selectedVariant.id);
  }

  // VARIANT

  updateSelectedVariant(card, variantId) {
    if (!card || !variantId) {
      return;
    }
    card.dataset.variantId = variantId;
    card.dataset.selectedVariantId = variantId;
    const checkbox = card.querySelector("[data-addon-checkbox]");
    if (checkbox) {
      checkbox.dataset.variantId = variantId;
      checkbox.value = variantId;
    }
  }

  // CLOSE DROPDOWNS

  // closeAllColorDropdowns(exceptDropdown = null) {
  //   this.productsContainer
  //     .querySelectorAll("[data-color-dropdown]")
  //     .forEach((dropdown) => {
  //       if (dropdown === exceptDropdown) {
  //         return;
  //       }

  //       const button = dropdown.querySelector("[data-color-dropdown-button]");

  //       const menu = dropdown.querySelector("[data-color-dropdown-menu]");

  //       if (button) {
  //         button.setAttribute("aria-expanded", "false");
  //       }

  //       if (menu) {
  //         menu.hidden = true;
  //       }
  //     });
  // }

  closeAllColorDropdowns(exceptDropdown = null) {
    this.productsContainer
      .querySelectorAll(
        "[data-color-dropdown], [data-size-dropdown]"
      )
      .forEach((dropdown) => {
        if (dropdown === exceptDropdown) return;

        const button = dropdown.querySelector(
          "[data-color-dropdown-button], [data-size-dropdown-button]"
        );

        const menu = dropdown.querySelector(
          "[data-color-dropdown-menu], [data-size-dropdown-menu]"
        );

        if (button) {
          button.setAttribute("aria-expanded", "false");
        }

        if (menu) {
          menu.hidden = true;
        }
      });
  }

}

//  INITIALIZE

function initCompleteTheFit() {
  document.querySelectorAll(".complete-the-fit").forEach((section) => {
    if (section.dataset.completeFitInitialized) {
      return;
    }

    section.dataset.completeFitInitialized = "true";

    new CompleteTheFit(section);
  });
}

document.addEventListener("DOMContentLoaded", initCompleteTheFit);

// SHOPIFY CUSTOMIZER

document.addEventListener("shopify:section:load", (event) => {
  const section = event.target.querySelector(".complete-the-fit");

  if (!section) {
    return;
  }

  section.dataset.completeFitInitialized = "true";

  new CompleteTheFit(section);
});

document.addEventListener("click", (event) => {
  document.querySelectorAll("[data-color-dropdown]").forEach((dropdown) => {
    if (dropdown.contains(event.target)) {
      return;
    }

    const button = dropdown.querySelector("[data-color-dropdown-button]");

    const menu = dropdown.querySelector("[data-color-dropdown-menu]");

    if (button) {
      button.setAttribute("aria-expanded", "false");
    }

    if (menu) {
      menu.hidden = true;
    }
  });
});

// do not Toch This JS

(function () {
  // console.log('COMPLETE THE FIT JS INITIALIZED');

  window.completeFitSelectedProducts = [];

  function getAllCheckboxes() {
    return Array.from(document.querySelectorAll("[data-addon-checkbox]"));
  }

  function updateCompleteFitVisibility() {
    document.querySelectorAll(".complete-the-fit").forEach((container) => {
      const checkboxes = container.querySelectorAll("[data-addon-checkbox]");

      const hasRecommendations = checkboxes.length > 0;

      container.classList.toggle("hidden", !hasRecommendations);
    });
  }

  function updateCompleteFitArray() {
    const checkboxes = getAllCheckboxes();
    const selectedProducts = [];

    checkboxes.forEach((checkbox) => {
      if (!checkbox.checked) return;

      // IMPORTANT:
      // checkbox.value is the currently selected variant
      const variantId = checkbox.value;

      if (!variantId) {
        console.warn(
          "[CompleteFit] Selected checkbox has no variant value:",
          checkbox,
        );
        return;
      }

      selectedProducts.push({
        productId: checkbox.dataset.productId || "",
        variantId: String(variantId),
        quantity: Number(checkbox.dataset.quantity || 1),
        handle: checkbox.dataset.productHandle || "",
        title: checkbox.dataset.productTitle || "",
      });
    });

    window.completeFitSelectedProducts = selectedProducts;

    return selectedProducts;
  }

  function bindCheckbox(checkbox) {
    if (checkbox.dataset.completeFitBound === "true") {
      return;
    }

    checkbox.dataset.completeFitBound = "true";

    checkbox.addEventListener("change", function () {
    //   console.log(
    //     "[CompleteFit] Checkbox changed:",
    //     checkbox.value,
    //     checkbox.checked,
    //   );

      updateCompleteFitArray();
    });
  }

  function bindAllCheckboxes() {
    const checkboxes = getAllCheckboxes();

    checkboxes.forEach(bindCheckbox);

    updateCompleteFitArray();
    updateCompleteFitVisibility();
  }

  function clearSelections() {
    // console.log("[CompleteFit] Clearing selections...");

    const checkboxes = document.querySelectorAll("[data-addon-checkbox]");

    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;

      checkbox.removeAttribute("checked");

      checkbox.dispatchEvent(
        new Event("change", {
          bubbles: true,
        }),
      );
    });

    // Clear global selected products
    window.completeFitSelectedProducts = [];

    // console.log(
    //   "[CompleteFit] Selections cleared:",
    //   window.completeFitSelectedProducts,
    // );
  }

  bindAllCheckboxes();

  /*
   * Watch for dynamically loaded/swapped
   * Complete The Fit products.
   */
  const observer = new MutationObserver(function () {
    bindAllCheckboxes();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  /*
   * Public API
   */
  window.CompleteFit = {
    getSelectedProducts() {
      return updateCompleteFitArray();
    },

    getSelectedVariantIds() {
      const products = updateCompleteFitArray();

      return products.map((product) => product.variantId);
    },

    getGlobalProducts() {
      return window.completeFitSelectedProducts;
    },

    clearSelectedProducts() {
      clearSelections();
    },

    /*
     * Alias specifically for Add To Cart
     */
    clearSelections() {
      clearSelections();
    },
  };

//   console.log(
//     "[CompleteFit] Initial global array:",
//     window.completeFitSelectedProducts,
//   );
})();

// Custom JS TO extra ADD ON Products

document.addEventListener(
  "click",
  async function (event) {
    const button = event.target.closest('product-form button[type="submit"]');

    if (!button) return;

    const productForm = button.closest("product-form");
    if (!productForm) return;

    const form = productForm.querySelector('form[action*="/cart/add"]');

    if (!form) return;

    const formId = form.getAttribute("id") || "";

    if (!formId.includes("-main-") && !formId.includes("__main")) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const mainVariantId = form.elements.id?.value;
    const quantity = Number(form.elements.quantity?.value || 1);

    if (!mainVariantId) {
      console.error("[PDP] Main variant ID not found");
      return;
    }

    const selectedProducts = window.CompleteFit?.getSelectedProducts?.() || [];

    // Main product
    const items = [
      {
        id: Number(mainVariantId),
        quantity: quantity,
      },
    ];

    // Complete The Fit products
    selectedProducts.forEach((product) => {
      const variantId = Number(product.variantId);
      const addonQuantity = Number(product.quantity || 1);

      if (!variantId) {
        console.warn("[PDP] Invalid Complete Fit variant:", product);
        return;
      }

      items.push({
        id: variantId,
        quantity: addonQuantity,
      });
    });

    // console.log("[PDP] FINAL CART ITEMS:", items);

    try {
      button.setAttribute("aria-busy", "true");

      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:start", {
          bubbles: true,
        }),
      );

      // Prepare bundled sections
      let sectionsToBundle = [];

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: {
            sections: sectionsToBundle,
          },
        }),
      );

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          items,
          sections: sectionsToBundle.join(","),
          sections_url: `${Shopify.routes.root}variants/${mainVariantId}`,
        }),
      });

      const responseJson = await response.json();

    //   console.log("[PDP] Cart response:", responseJson);

      if (!response.ok) {
        throw new Error(
          responseJson.description || "Unable to add products to cart",
        );
      }

      window.CompleteFit?.clearSelections?.();
      // Get latest cart
      const cartContent = await (
        await fetch(`${Shopify.routes.root}cart.js`)
      ).json();

      cartContent.sections = responseJson.sections;

      // Same events the theme ProductForm normally fires
      form.dispatchEvent(
        new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.items || [responseJson],
            cart: cartContent,
            onSuccessDo: form.elements.on_success?.value,
          },
        }),
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            onSuccessDo: form.elements.on_success?.value,
            cart: cartContent,
          },
        }),
      );

    //   console.log("[PDP] Products added successfully");
    //   console.log("[PDP] Cart:", cartContent);
    } catch (error) {
      console.error("[PDP] Add to cart failed:", error);

      form.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message,
          },
        }),
      );

      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } finally {
      button.removeAttribute("aria-busy");

      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", {
          bubbles: true,
        }),
      );
    }
  },
  true,
);
